export const hygene = ['privacy', 'cookies', 'loggin'];
